import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AlertMessage {
  type: 'success' | 'error' | 'info' | 'warning';
  summary: string;
  detail: string;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private readonly alertSubject = new BehaviorSubject<AlertMessage | null>(null);
  readonly alert$ = this.alertSubject.asObservable();
  private clearTimer: ReturnType<typeof setTimeout> | null = null;

  showAlert(message: AlertMessage, autoCloseMs?: number): void {
    this.alertSubject.next(message);

    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
      this.clearTimer = null;
    }

    if (autoCloseMs && autoCloseMs > 0) {
      this.clearTimer = setTimeout(() => this.clearAlert(), autoCloseMs);
    }
  }

  clearAlert(): void {
    if (this.clearTimer) {
      clearTimeout(this.clearTimer);
      this.clearTimer = null;
    }
    this.alertSubject.next(null);
  }
}
